import { render } from "./FullLayout.vue?vue&type=template&id=05779f9d&scoped=true"
import script from "./FullLayout.vue?vue&type=script&lang=js"
export * from "./FullLayout.vue?vue&type=script&lang=js"

import "./FullLayout.vue?vue&type=style&index=0&id=05779f9d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05779f9d"]])

export default __exports__